import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedDate } from 'react-intl';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import ListIcon from 'material-ui/svg-icons/action/list';
import { DateStyles } from '../../constants/CentricConstants';

const SystemTaskRow   = ({ row, children, ...others }) => (
    <TableRow {...others} >
        {children && children[0]}
        <TableRowColumn>{row.name}</TableRowColumn>
        <TableRowColumn>
            {row.schedule && (<FormattedDate {...DateStyles.full} value={new Date(row.schedule)} />)}
        </TableRowColumn>
        <TableRowColumn>{row.repeatInterval || " - "}</TableRowColumn>
        <TableRowColumn>{row.active ? "Yes" : "No"}</TableRowColumn>
        <TableRowColumn className="table-row-actions">
            <Link to={`/dashboard/system/task/${row.id}/jobs`} >
                <ListIcon />
            </Link>
        </TableRowColumn>
    </TableRow>
);

SystemTaskRow.propTypes = {
    row:        PropTypes.shape({
        id:         PropTypes.number.isRequired,
    })
};
export default SystemTaskRow;
